import { TextField } from '@mui/material';

function ReadOnlyField({label, value}) {
    return (
        <TextField label={label} fullWidth value={value} InputProps={{readOnly: true}} sx={{mt: 2}}/>
    );
}

export default ReadOnlyField;
